import produce from 'immer';
import {
    ADD_NEW_QUESTION_PAGES,
    CAMPAIGN_ADD_LEADTYPE,
  CAMPAIGN_LIST_FAIL,
  CAMPAIGN_LIST_REQUEST,
  CAMPAIGN_LIST_SUCCESS,
  CAMPAIGN_REQUEST,
  CAMPAIGN_REQUEST_FAIL,
  CAMPAIGN_REQUEST_SUCCESS
} from '../actions/campaignActions';

const initialState = {
    campaigns: [],
    filter: { active: '1' },
    pagination: {
        currentPage: 1,
        itemsPerPage: 5,
        totalItems: 64,
        totalPages: 13,
    },
    campaign: {
        id: 1,
        leads: 0,
        title: '',
        visitors: 0,
        leadRequirementSets: [],
        questionPages: []
    },
    loading: false
};

export const campaignReducer = (state = initialState, action) => {
    switch (action.type) {
        case CAMPAIGN_LIST_REQUEST: {
            return {
                ...state,
                loading: true,
            }
        }
        case CAMPAIGN_LIST_SUCCESS: {
            const { campaigns, pagination, filter } = action.payload;
            return produce(state, (draft) => {
                draft.campaigns = campaigns;
                draft.pagination = pagination;
                draft.filter = filter;
                draft.loading = false;
            });
        }
        case CAMPAIGN_LIST_FAIL: {
            return produce(state, () => {
              // Maybe store error
            });
        }
        case CAMPAIGN_REQUEST: {
            return {
                ...state,
                loading: true,
            }
        }
        case CAMPAIGN_REQUEST_SUCCESS: {
            const { campaign } = action.payload;

            return produce(state, (draft) => {
                draft.campaign = campaign;
                draft.loading = false;
            });
        }
        case CAMPAIGN_REQUEST_FAIL: {
            return produce(state, () => {
              // Maybe store error
            });
        }
        case CAMPAIGN_ADD_LEADTYPE: {
            return produce(state, (draft) => {
                draft.campaign.leadRequirementSets.push(action.payload)
            });
        }
        case ADD_NEW_QUESTION_PAGES: {
            return produce(state, (draft) => {
                console.log(action.payload, draft.campaign.questionPages)
                draft.campaign.questionPages.push(action.payload)
            });
        }
        default:
            return state
    }
}
